module.exports = __webpack_public_path__ + "img/xkh.63d61646.jpg";